import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';

import './HeaderStepper.scss';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.primary.main,
  },
}));

function HeaderStepper(props) {
  const classes = useStyles();
  var title = props.title || "Let's get the best quote for you";

  return (
    <div className={`header-stepper ${props.whiteBg ? 'white-background' : ''}`}>
      <Container fluid className={`head shadow ${classes.header} ${props.hidden ? 'd-none' : ''} ${!props.hideProgressTracker ? 'extend-head' : ''}`}>
        <Container className={props.hideProgressTracker ? 'h-100' : ''}>
          <Row className={props.hideProgressTracker ? 'h-100' : ''}>
            <Col className="d-flex align-items-center h1-wrapper">
              <h1>{title}</h1>
            </Col>
            <div className="decor d-flex position-absolute">
              <Image src="./circle-crop.png" alt="" />
            </div>
          </Row>

          {!props.hideProgressTracker &&
            <ProgressTracker {...props} />
          }

        </Container>
      </Container>

      <Container fluid className="page-content">
        {props.children}
      </Container>
    </div>
  );
}

function ProgressTracker(props) {

  let percentCompleted = ((props.step - .5) / props.totalSteps) * 100;

  if (props.lastStep) {
    percentCompleted = 100;
  }

  return (
    <Row className="progressTrackerRow">
      <Col>
        <div className="progressTracker shadow">
          <h2 className="progressTrackerTitle">{props.stepName}</h2>
          <p className="progressSteps">
            Step {props.step} of {props.totalSteps}
          </p>
          <LinearProgress variant="determinate" value={percentCompleted} className="progress" aria-hidden="true" />
        </div>
      </Col>
    </Row>
  )
}

export { HeaderStepper }

HeaderStepper.propTypes = {
  hideProgressTracker: PropTypes.bool,
  hidden: PropTypes.bool,
  title: PropTypes.string,
  whiteBg: PropTypes.bool,
  lastStep: PropTypes.bool,
}

ProgressTracker.propTypes = {
  stepName: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/HeaderStepper/HeaderStepper.js